import React from 'react';
// import ReactLoading from 'react-loading';
import { css } from '@emotion/core';
import { HashLoader } from 'react-spinners';

const override = css`
    display: block;
    margin: 20% auto 0;
    border-color: red;
`;


const SaveLoader = ({ type }) => (
    // <div className="save-loader" >
    //     <ReactLoading type={type} color={color} height={120} width={120} className="page-loader" />
    // </div>
    <div className='save-loader'>
        <HashLoader
            css={override}
            sizeUnit={"px"}
            size={40}
            color="#04b7a2"
        // loading={this.state.loading}
        />
        {type === true &&
            <p className="page-loader-text">
                We Are Searching For You ...
            </p>
        }
    </div>
);

export default SaveLoader;



// WEBPACK FOOTER //
// ./src/components/loader/SaveLoader.js